import _ from 'lodash';
import * as React from 'react';
import * as uuid from 'uuid';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as api from '../../../api';

import styles from './index.module.css';

import { Button } from '../../Button';
import { InfoMessage } from '../../InfoMessage';
import { TextInput } from '../../TextInput';

import Grid from '@material-ui/core/Grid';

const FIRST_NAME_LABEL = "Care Provider's First Name";
const LAST_NAME_LABEL = "Care Provider's Last Name";

interface Props extends WithTranslation {
  careProvider: api.CareProvider.CareProviderWithAddress;
  onSave: (careProvider: api.CareProvider.CareProviderWithAddress) => void;
}

interface State {
  selectedCareProvider: api.CareProvider.CareProviderWithAddress;
  errorMessage: string;
}

class ConfirmCareProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedCareProvider: props.careProvider,
      errorMessage: '',
    };
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    const { careProvider } = this.props;

    if (prevProps.careProvider !== careProvider) {
      this.setState({
        selectedCareProvider: careProvider,
      });
    }
  }

  setSelectedCareProviderField = (name: string, value: string) => {
    const selectedCareProvider = {
      ...this.state.selectedCareProvider,
      [name]: value,
    };

    const displayName = [
      selectedCareProvider.firstName,
      selectedCareProvider.lastName,
    ].join(' ');

    this.setState({
      selectedCareProvider: { ...selectedCareProvider, displayName },
    });
  };

  setTextField = (
    event:
      | React.KeyboardEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = event.currentTarget;

    this.setSelectedCareProviderField(name, value);
  };

  saveCareProvider = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const { onSave, t } = this.props;
    const { selectedCareProvider } = this.state;

    const requiredFields = {
      firstName: FIRST_NAME_LABEL,
      lastName: LAST_NAME_LABEL,
    };
    const missingField = _.some(requiredFields, (v, k) => {
      if (
        !selectedCareProvider[
          k as keyof api.CareProvider.CareProviderWithAddress
        ]
      ) {
        this.setState({ errorMessage: t('errorMessage', { input: t(v) }) });
        return true;
      }

      return false;
    });
    if (missingField) {
      return;
    }

    const { displayName, firstName, lastName } = selectedCareProvider;

    onSave({
      ...selectedCareProvider,
      id: uuid.v4(),
      displayName: displayName.toUpperCase(),
      firstName: firstName.toUpperCase(),
      lastName: lastName.toUpperCase(),
    });
    this.setState({ errorMessage: '' });
  };

  render() {
    const { t } = this.props;
    const { selectedCareProvider: careProvider, errorMessage } = this.state;
    const { firstName, lastName } = careProvider || {};

    return (
      <div>
        {errorMessage ? (
          <div className={styles.InfoMessage}>
            <InfoMessage isError={true}>{errorMessage}</InfoMessage>
          </div>
        ) : null}
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <label
                    htmlFor="confirm-care-provider-firstname"
                    className={styles.label}
                  >
                    {t(FIRST_NAME_LABEL)}
                  </label>
                </Grid>
                <Grid item xs={12}>
                  <TextInput
                    id="confirm-care-provider-firstname"
                    autoFocus={true}
                    name="firstName"
                    value={firstName}
                    onChange={this.setTextField}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <label
                    htmlFor="confirm-care-provider-lastname"
                    className={styles.label}
                  >
                    {t(LAST_NAME_LABEL)}
                  </label>
                </Grid>
                <Grid item xs={12}>
                  <TextInput
                    id="confirm-care-provider-lastname"
                    name="lastName"
                    value={lastName}
                    onChange={this.setTextField}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={styles.button}>
              <Button children={t('Save')} onClick={this.saveCareProvider} />
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}

export default withTranslation()(ConfirmCareProvider);
